import Layout from '@layouts/withoutNaviagtion/withoutNavigationLayout';
import VendorListNavigation from '@components/Vendors/vendorlist-navigation';
import React, { useRef, useState, useEffect } from 'react';
import LocationNavigation from '@components/Locations/location-navigation';
import DashboardLayout from '@layouts/dashboard/dashboard-layout';
import { NavLink } from 'react-router-dom';
import Header from '@components/common/Header';
import SimpleReactValidator from 'simple-react-validator';
import { useParams, useNavigate } from 'react-router-dom';
import InputField from '@_common/InputRuleFeild';
import { getValue } from '@utils/lodash';
import {
	adminGetCitiesListManagement,
	adminGetCountriesListManagement,
	adminGetListManagementGroupCode,
	adminGetStatesListManagement,
} from '@services/list-management.service';
import { toast } from 'react-toastify';
import './vendors-add-details.scss';
import {
	clientCreateLocation,
	clientGetSpecificLocation,
	clientUpdateSpecificLocation,
} from '@services/location.service';
import {
	clientCreateVendor,
	clientGetSpecificVendor,
	clientUpdateSpecificVendor,
} from '@services/vendors.service';
import _ from 'lodash';
import { useCallbackPrompt } from '../../../prompt/useCallbackPrompt';
import PromptModal from '../../../prompt/modal';
import { sanitizeInput } from '@_common/dompurify';
interface ILocationDetailProps {}

const LocationDetail: React.FunctionComponent<ILocationDetailProps> = (
	props:any
) => {
	let params = useParams();
	let navigate = useNavigate();
	/* -------------------------------------------------------------------------- */
	/*                               UseState Section                             */
	/* -------------------------------------------------------------------------- */
	const simpleValidator = useRef(new SimpleReactValidator());
	const [, forceUpdate] = useState(0);
	const [request, setRequest] = useState<any>({
		vendor_code: '',
		vendor_name: '',
		vendor_type: 'PRIME_VENDOR',
		parent_id: '',
		industry: '',
		business_type: '',
		// region: "",
		address1: '',
		address2: '',
		country_id: '101',
		state_id: '',
		city_id: '',
		pincode: '',
		country_code_phone1: '',
		phone1: '',
		country_code_phone2: '',
		phone2: '',
		email1: '',
		is_poc_email1: true,
		email2: '',
		is_poc_email2: true,
	});
	const [dirtyFields, setDirtyFields] = useState<any>({
		vendor_code: '',
		vendor_name: '',
		vendor_type: 'PRIME_VENDOR',
		parent_id: '',
		industry: '',
		business_type: '',
		// region: "",
		address1: '',
		address2: '',
		country_id: '101',
		state_id: '',
		city_id: '',
		pincode: '',
		country_code_phone1: '',
		phone1: '',
		country_code_phone2: '',
		phone2: '',
		email1: '',
		is_poc_email1: true,
		email2: '',
		is_poc_email2: true,
	});
	const [countryList, setCountryList] = useState([]);
	const [states, setStates] = useState([]);
	const [citiesList, setCityList] = useState([]);

	const [industryTypeList, setIndustryTypeList] = useState([]);
	const [businessTypeList, setBusinessTypeList] = useState([]);
	const [regionTypeList, setRegionTypeList] = useState([]);
	const [vendorTypeList] = useState([
		{ value: 'PRIME_VENDOR', label: 'PRIME_VENDOR' },
		{ value: 'SERVICING_VENDOR', label: 'SERVICING_VENDOR' },
	]);

	const [isLoading, setIsLoading] = useState(false);
	const [mobile_code1, setMobile_code1] = useState<any>('');
	const [mobile_code2, setMobile_code2] = useState<any>('');

	const reset = () => {
		setRequest({
			...request,
			vendor_code: '',
			vendor_name: '',
			vendor_type: 'PRIME_VENDOR',
			parent_id: '',
			industry: '',
			business_type: '',
			// entity_name: '',
			// region: "",
			address1: '',
			address2: '',
			country_id: '101',
			state_id: '',
			city_id: '',
			pincode: '',
			country_code_phone1: '',
			phone1: '',
			country_code_phone2: '',
			phone2: '',
			email1: '',
			is_poc_email1: true,
			email2: '',
			is_poc_email2: true,
		});
		setDirtyFields({
			...dirtyFields,
			vendor_code: '',
			vendor_name: '',
			vendor_type: 'PRIME_VENDOR',
			parent_id: '',
			industry: '',
			business_type: '',
			// entity_name: '',
			// region: "",
			address1: '',
			address2: '',
			country_id: '101',
			state_id: '',
			city_id: '',
			pincode: '',
			country_code_phone1: '',
			phone1: '',
			country_code_phone2: '',
			phone2: '',
			email1: '',
			is_poc_email1: true,
			email2: '',
			is_poc_email2: true,
		});
	};

	/* -------------------------------------------------------------------------- */
	/*                               UseEffect Section                            */
	/* -------------------------------------------------------------------------- */

	useEffect(() => {
		getIndustryList();
		getBusinessTypeList();
		// getRegionList();
		getCountriesList();

		if (getValue(params, `id`, '')) {
			getData(getValue(params, `id`, ''));
		}
	}, [props.permissionAPITriggered]);

	useEffect(() => {
		getStatesList(request.country_id);
		if (request.state_id) {
			getCitiesList(request.state_id);
		}
	}, [request.country_id, request.state_id]);
	/* -------------------------------------------------------------------------- */
	/*                               API Section                                  */
	/* -------------------------------------------------------------------------- */

	const getData = async (id: string) => {
		try {
			let resp = await clientGetSpecificVendor(id);
			if (resp) {
				setRequest({
					...request,
					country_id: getValue(resp, `data.country.id`, ''),
					state_id: getValue(resp, `data.state.id`, ''),
					city_id: getValue(resp, `data.city.id`, ''),
					address1: getValue(resp, `data.address1`, ''),
					address2: getValue(resp, `data.address2`, ''),
					// entity_name: getValue(resp, `data.entity_name`, ''),
					vendor_code: getValue(resp, `data.vendor_code`, ''),
					pincode: getValue(resp, `data.pincode`, ''),
					vendor_name: getValue(resp, `data.vendor_name`, ''),
					vendor_type: getValue(resp, `vendor_type`, ''),
					location_id: getValue(resp, `data.location_id`, ''),
					industry: getValue(resp, `data.industry.id`, ''),
					business_type: getValue(resp, `data.business_type.id`, ''),
					// region: getValue(resp, `data.region.id`, ""),
					phone1: getValue(resp, `data.phone1`, ''),
					phone2: getValue(resp, `data.phone2`, ''),
					email1: getValue(resp, `data.email1`, ''),
					email2: getValue(resp, `data.email2`, ''),
					is_poc_email1: getValue(resp, `data.is_poc_email1`, ''),
					is_poc_email2: getValue(resp, `data.is_poc_email2`, ''),
				});

				if (getValue(resp, `data.country.id`, '')) {
					getStatesList(getValue(resp, `data.country.id`, ''));
				}
			}
		} catch (error) {}
	};

	const getCountriesList = async () => {
		try {
			let resp = await adminGetCountriesListManagement();
			if (resp) {
				setCountryList(
					getValue(resp, `data.countries`, []).map((item: object) => ({
						...item,
						value: getValue(item, `name`, ''),
						label: getValue(item, `name`, ''),
					}))
				);
			} else {
			}
		} catch (error) {}
	};

	const getStatesList = async (countryId: number) => {
		try {
			let resp = await adminGetStatesListManagement(countryId);
			if (resp) {
				setStates(
					getValue(resp, `data.states`, []).map((item: object) => ({
						...item,
						value: getValue(item, `name`, ''),
						label: getValue(item, `name`, ''),
					}))
				);
			} else {
			}
		} catch (error) {}
	};

	const getIndustryList = async () => {
		try {
			let resp = await adminGetListManagementGroupCode('industry');
			if (resp) {
				let list =
					getValue(resp, `data.listItems.length`, 0) > 0
						? getValue(resp, `data.listItems`, []).filter((item: object) =>
								getValue(item, `is_active`, '')
						  )
						: [];
				setIndustryTypeList(
					list.map((item: object) => ({
						id: getValue(item, `id`, ''),
						is_active: getValue(item, `is_active`, ''),
						text: getValue(item, `text`, ''),
						value: getValue(item, `text`, ''),
						label: getValue(item, `text`, ''),
					}))
				);
			} else {
			}
		} catch (error) {}
	};

	const getCitiesList = async (stateId: number) => {
		try {
			let resp = await adminGetCitiesListManagement(stateId);
			if (resp) {
				setCityList(
					getValue(resp, `data.cities`, []).map((item: object) => ({
						...item,
						value: getValue(item, `name`, ''),
						label: getValue(item, `name`, ''),
					}))
				);
			} else {
			}
		} catch (error) {}
	};

	const getRegionList = async () => {
		try {
			let resp = await adminGetListManagementGroupCode('region');
			if (resp) {
				let list =
					getValue(resp, `data.listItems.length`, 0) > 0
						? getValue(resp, `data.listItems`, []).filter((item: object) =>
								getValue(item, `is_active`, '')
						  )
						: [];
				setRegionTypeList(
					list.map((item: object) => ({
						id: getValue(item, `id`, ''),
						is_active: getValue(item, `is_active`, ''),
						text: getValue(item, `text`, ''),
						value: getValue(item, `text`, ''),
						label: getValue(item, `text`, ''),
					}))
				);
			} else {
			}
		} catch (error) {}
	};

	const getBusinessTypeList = async () => {
		try {
			let resp = await adminGetListManagementGroupCode('business-type');
			if (resp) {
				let list =
					getValue(resp, `data.listItems.length`, 0) > 0
						? getValue(resp, `data.listItems`, []).filter((item: object) =>
								getValue(item, `is_active`, '')
						  )
						: [];
				setBusinessTypeList(
					list.map((item: object) => ({
						id: getValue(item, `id`, ''),
						is_active: getValue(item, `is_active`, ''),
						text: getValue(item, `text`, ''),
						value: getValue(item, `text`, ''),
						label: getValue(item, `text`, ''),
					}))
				);
			} else {
			}
		} catch (error) {}
	};
	const handleSubmit = async () => {
		const formValid = simpleValidator.current.allValid();
		if (!formValid) {
			simpleValidator.current.showMessages();
			forceUpdate(1);
		} else {
			let payload = JSON.parse(JSON.stringify(request));

			payload.pincode = parseInt(payload.pincode);
			payload.country_id = parseInt(payload.country_id);
			payload.state_id = parseInt(payload.state_id);
			payload.city_id = parseInt(payload.city_id);
			payload.country_code_phone1 = getValue(mobile_code1, `value`, '').split(
				' '
			)[0];
			payload.country_code_phone2 = getValue(mobile_code2, `value`, '').split(
				' '
			)[0];
			Object.keys(payload).forEach((key) => {
				if (!payload[key] || payload[key] === undefined) {
					delete payload[key];
				}
			});
			if (getValue(params, `id`, '')) {
				try {
					setIsLoading(true);
					let resp = await clientUpdateSpecificVendor(
						getValue(params, `id`, ''),
						payload
					);
					if (resp) {
						setIsLoading(false);
						toast.success(getValue(resp, 'message', ''));
						navigate(`/configuration/vendors`);
					} else {
						setIsLoading(false);
					}
				} catch (error) {
					setIsLoading(false);
				}
			} else {
				try {
					setIsLoading(true);
					let resp = await clientCreateVendor(payload);
					if (resp) {
						reset();
						setIsLoading(false);
						confirmNavigation();
						toast.success(getValue(resp, 'message', ''));
						if (getValue(resp, 'data.parent_id', '')) {
							// navigate(
							// 	`/configuration/vendors/detail/${getValue(resp, 'data.parent_id', '')}`
							// );
							navigate(`/configuration/vendors`);
						} else {
							navigate(`/configuration/vendors`);
						}
					} else {
						setIsLoading(false);
					}
				} catch (error) {
					setIsLoading(false);
				}
			}
		}
	};

	/* -------------------------------------------------------------------------- */
	/*                               Onchange section                             */
	/* -------------------------------------------------------------------------- */

	const handleChangeSelect = (e: any, type: string) => {
		if (type === 'country_id') {
			getStatesList(e.id);
			setRequest({
				...request,
				country_id: e.id,
			});
		}
		if (type === 'state_id') {
			getCitiesList(e.id);
			setRequest({
				...request,
				state_id: e.id,
			});
		}
		if (type === 'industry') {
			setRequest({
				...request,
				industry: e.id,
			});
		}
		if (type === 'business_type') {
			setRequest({
				...request,
				business_type: e.id,
			});
		}
		if (type === 'city_id') {
			setRequest({
				...request,
				city_id: e.id,
			});
		}
		if (type === 'region') {
			setRequest({
				...request,
				region: e.id,
			});
		}
		if (type === 'vendor_type') {
			setRequest({
				...request,
				vendor_type: e.value,
			});
		}
	};

	const handleChangeText = (e: any) => {
		const { name, value } = e.target;
		setRequest({
			...request,
			[name]: sanitizeInput(value),
		});
	};

	const handleChangeDate = (e: any) => {
		setRequest({
			...request,
			commencement_date: e,
		});
	};

	const handleChangeCountryCode = (e: any) => {};
	/* -------------------------------------------------------------------------- */
	/*                                Prompt Section                              */
	/* -------------------------------------------------------------------------- */
	const [isChanged, setIsChanged] = useState(false);
	useEffect(() => {
		setIsChanged(
			_.isEqualWith(request, dirtyFields, (a: any, b: any) => {
				// if both are null or equal to an empty string then they are equal
				if ((_.isNull(a) || a === '') && (_.isNull(b) || b === '')) return true;
			})
		);
	});
	const [showPrompt, confirmNavigation, cancelNavigation]: any =
		useCallbackPrompt(!isChanged);

	return (
		<Layout>
			<PromptModal
				showDialog={showPrompt}
				confirmNavigation={confirmNavigation}
				cancelNavigation={cancelNavigation}
			/>

			<div className="common-sticky-header">
				<div className="inner-page-navigation-with-back-cta-buttons position-relative">
					<div className="container-fluid d-flex justify-content-between align-items-center">
						<div className="d-flex">
							<NavLink to={`/configuration/vendors`} className="">
								<img
									src="/images/back-link.svg"
									className="img-fluid"
									height={24}
									width={24}
								/>
							</NavLink>
							<div className="inner-page-navigation-with-back-cta-button__header">
								<h4 className="inner-page-navigation-with-back-cta-button__header-title">
									Add to Vendors
								</h4>
							</div>
						</div>
						<div className="user-details-wrapper__cta-btns">
							<NavLink to={`/configuration/vendors`}>
								<button className="ascent-button ascent-button--header-buttons ascent-button--primary">
									Cancel
								</button>
							</NavLink>
							{isLoading ? (
								<button className="ascent-button ascent-button--header-buttons ascent-button--secondary">
									Please wait...
								</button>
							) : (
								<button
									className={`ascent-button ascent-button--header-buttons ascent-button--${
										isChanged ? 'primary' : 'secondary'
									}`}
									disabled={isChanged}
									onClick={handleSubmit}
								>
									{getValue(params, `id`, '') ? 'Update' : 'Submit'}
								</button>
							)}
						</div>
					</div>
				</div>
			</div>

			<div className="user-details-wrapper m-0 pt-5">
				<div className="checkpoint-active-details-wrapper__form-wrapper">
					<div className="checkpoint-active-details-wrapper__form-content">
						<h4 className="mb-3">
							{getValue(params, `id`, '') ? 'Update' : 'Add'} Vendor
						</h4>
						<div className="user-details-wrapper__form-group form-group">
							<label className="checkpoint-active-details__label">
								Vendor Organization Name <span>*</span>
							</label>
							<InputField
								inputType="TEXT"
								placeholder="Enter Location Name"
								className="form-control w-100"
								name="vendor_name"
								id="vendor_name"
								value={getValue(request, `vendor_name`, '')}
								onChange={(e: any) => handleChangeText(e)}
								label="Vendor Name"
								validator={simpleValidator}
							/>
						</div>
						<div className="user-details-wrapper__form user-details-wrapper__form--grid-gap-vendor-profile">
							<div className="user-details-wrapper__form-group form-group">
								<label className="checkpoint-active-details__label">
									Vendor Code <span>*</span>
								</label>
								<InputField
									inputType="TEXT"
									placeholder="Enter Vendor Code"
									className="form-control w-100"
									name="vendor_code"
									id="vendor_code"
									value={getValue(request, `vendor_code`, '')}
									onChange={(e: any) => handleChangeText(e)}
									label="Vendor Code"
									validator={simpleValidator}
								/>
							</div>

							{/* <div className="user-details-wrapper__form-group form-group">
									<label className="checkpoint-active-details__label">
										Vendor Type <span>*</span>
									</label>
									<InputField
										inputType="INPUT_REACT_SELECT"
										placeholder="Choose Group"
										className="form-control w-100"
										name="vendor_type"
										id="vendor_type"
										options={vendorTypeList}
										value={vendorTypeList.filter(
											(item: object) =>
												getValue(item, `value`, "") ==
												getValue(request, `vendor_type`, "")
										)}
										onChange={(e: any) => handleChangeSelect(e, "vendor_type")}
										label="Vendor Type"
										validator={simpleValidator}
									/>
								</div> */}

							{/* <div className="user-details-wrapper__form-group form-group">
								<label className="checkpoint-active-details__label">
									Entity Name <span>*</span>
								</label>
								<InputField
									inputType="TEXT"
									placeholder="Enter Entity Name"
									className="form-control w-100"
									name="entity_name"
									id="entity_name"
									value={getValue(request, `entity_name`, '')}
									onChange={(e: any) => handleChangeText(e)}
									label="Entity Name"
									validator={simpleValidator}
								/>
							</div> */}

							<div className="user-details-wrapper__form-group form-group pb-3">
								<label className="checkpoint-active-details__label">
									Industry <span>*</span>
								</label>
								<InputField
									inputType="INPUT_REACT_SELECT"
									placeholder="Enter Industry"
									className="form-control w-100"
									name="industry"
									id="industry"
									options={industryTypeList}
									value={industryTypeList.filter(
										(item: object) =>
											getValue(item, `id`, '') ==
											getValue(request, `industry`, '')
									)}
									onChange={(e: any) => handleChangeSelect(e, 'industry')}
									label="Industry"
									validator={simpleValidator}
								/>
							</div>

							<div className="user-details-wrapper__form-group form-group">
								<label className="checkpoint-active-details__label">
									Business Type <span>*</span>
								</label>
								<InputField
									inputType="INPUT_REACT_SELECT"
									placeholder="Enter Business Type"
									className="form-control w-100"
									name="business_type"
									id="business_type"
									options={businessTypeList}
									value={businessTypeList.filter(
										(item: object) =>
											getValue(item, `id`, '') ==
											getValue(request, `business_type`, '')
									)}
									onChange={(e: any) => handleChangeSelect(e, 'business_type')}
									label="Business Type"
									validator={simpleValidator}
								/>
							</div>

							<div className="user-details-wrapper__form-group form-group mb-3">
								<label className="checkpoint-active-details__label">
									Company Address (Line 1)<span>*</span>
								</label>
								<InputField
									inputType="TEXTAREAVENDOR"
									placeholder="Enter Company Address (Line 1)"
									className="form-control w-100"
									name="address1"
									id="address1"
									label="Address Line1"
									value={getValue(request, `address1`, '')}
									onChange={(e: any) => handleChangeText(e)}
									validator={simpleValidator}
								/>
							</div>

							<div className="user-details-wrapper__form-group form-group">
								<label className="checkpoint-active-details__label">
									Company Address (Line 2)<span></span>
								</label>
								<InputField
									inputType="TEXTAREAVENDOR"
									placeholder="Enter Company Address (Line 2)"
									className="form-control w-100"
									name="address2"
									id="address2"
									label="Address Line2"
									value={getValue(request, `address2`, '')}
									onChange={(e: any) => handleChangeText(e)}
									// validator={simpleValidator}
								/>
							</div>

							<div className="user-details-wrapper__form-group form-group pb-3">
								<label className="checkpoint-active-details__label">
									Country <span>*</span>
								</label>
								<InputField
									inputType="INPUT_REACT_SELECT"
									placeholder="Choose Country"
									className="form-control w-100"
									name="country_id"
									id="country_id"
									options={countryList}
									value={countryList.filter(
										(item: object) =>
											getValue(item, `id`, '') ==
											getValue(request, `country_id`, '')
									)}
									onChange={(e: any) => handleChangeSelect(e, 'country_id')}
									label="Country"
									validator={simpleValidator}
								/>
							</div>
							<div className="user-details-wrapper__form-group form-group">
								<label className="checkpoint-active-details__label">
									State <span>*</span>
								</label>
								<InputField
									inputType="INPUT_REACT_SELECT"
									placeholder="Choose State"
									className="form-control w-100"
									name="state_id"
									id="state_id"
									label="Last Name"
									options={states}
									value={states.filter(
										(item: object) =>
											getValue(item, `id`, '') ==
											getValue(request, `state_id`, '')
									)}
									onChange={(e: any) => handleChangeSelect(e, 'state_id')}
									validator={simpleValidator}
								/>
							</div>
							<div className="user-details-wrapper__form-group form-group">
								<label className="checkpoint-active-details__label">
									City <span>*</span>
								</label>
								<InputField
									inputType="INPUT_REACT_SELECT"
									placeholder="Choose State"
									className="form-control w-100"
									name="city_id"
									id="city_id"
									label="City"
									options={citiesList}
									value={citiesList.filter(
										(item: object) =>
											getValue(item, `id`, '') ==
											getValue(request, `city_id`, '')
									)}
									onChange={(e: any) => handleChangeSelect(e, 'city_id')}
									validator={simpleValidator}
								/>
							</div>

							<div className="user-details-wrapper__form-group form-group">
								<label className="checkpoint-active-details__label">
									Pincode <span>*</span>
								</label>
								<InputField
									inputType="TEXT"
									placeholder="Enter Pincode"
									className="form-control w-100"
									name="pincode"
									id="pincode"
									value={getValue(request, `pincode`, '')}
									onChange={(e: any) => handleChangeText(e)}
									label="Pincode"
									validator={simpleValidator}
								/>
							</div>

							<div className="user-details-wrapper__form-group form-group">
								<label className="checkpoint-active-details__label">
									Area Code <span>*</span>
								</label>
								<InputField
									inputType="INPUT_REACT_SELECT_COUNTYCODE"
									placeholder="Enter Area Code"
									className="form-control w-100"
									name="mobile_area_code"
									id="mobile_area_code"
									label="Mobile Area Code"
									value={mobile_code1}
									onChange={(e: any) => setMobile_code1(e)}
									validator={simpleValidator}
								/>
							</div>
							<div className="user-details-wrapper__form-group form-group">
								<label className="checkpoint-active-details__label">
									Primary Mobile Number <span>*</span>
								</label>
								<InputField
									inputType="PHONE"
									placeholder="Enter Phone Number 1"
									className="form-control w-100"
									name="phone1"
									id="phone1"
									label="Mobile Number"
									value={getValue(request, `phone1`, '')}
									onChange={(e: any) => handleChangeText(e)}
									validator={simpleValidator}
								/>
							</div>

							<div className="user-details-wrapper__form-group form-group">
								<label className="checkpoint-active-details__label">
									Area Code
								</label>
								<InputField
									inputType="INPUT_REACT_SELECT_COUNTYCODE"
									placeholder="Enter Area Code"
									className="form-control w-100"
									name="mobile_area_code"
									id="mobile_area_code"
									label="Mobile Area Code"
									value={mobile_code2}
									onChange={(e: any) => setMobile_code2(e)}
									// validator={simpleValidator}
								/>
							</div>
							<div className="user-details-wrapper__form-group form-group">
								<label className="checkpoint-active-details__label">
									Alternative Mobile Number
								</label>
								<InputField
									inputType="PHONE"
									placeholder="Enter Phone Number 1"
									className="form-control w-100"
									name="phone2"
									id="phone2"
									label="Mobile Number"
									value={getValue(request, `phone2`, '')}
									onChange={(e: any) => handleChangeText(e)}
									// validator={simpleValidator}
								/>
							</div>

							<div className="user-details-wrapper__form-group form-group">
								<label className="checkpoint-active-details__label">
									Primary Email <span>*</span>
								</label>
								<InputField
									inputType="EMAIL"
									placeholder="Enter Primary Email"
									className="form-control w-100"
									name="email1"
									id="email1"
									value={getValue(request, `email1`, '')}
									onChange={(e: any) => handleChangeText(e)}
									label="Email"
									validator={simpleValidator}
								/>
							</div>

							<div className="user-details-wrapper__form-group form-group">
								<label className="checkpoint-active-details__label">
									Secondary Email <span></span>
								</label>
								<InputField
									inputType="EMAIL"
									placeholder="Enter Primary Email"
									className="form-control w-100"
									name="email2"
									id="email2"
									value={getValue(request, `email2`, '')}
									onChange={(e: any) => handleChangeText(e)}
									label="email2"
								/>
							</div>
							{/* <div className="user-details-wrapper__form-group form-group">
									<label className="checkpoint-active-details__label">
										Region <span>*</span>
									</label>
									<InputField
										inputType="INPUT_REACT_SELECT"
										placeholder="Choose Region"
										className="form-control w-100"
										name="region"
										id="region"
										options={regionTypeList}
										value={regionTypeList.filter(
											(item: object) =>
												getValue(item, `id`, "") ==
												getValue(request, `region`, "")
										)}
										onChange={(e: any) => handleChangeSelect(e, "region")}
										label="Region"
										validator={simpleValidator}
									/>
								</div> */}
						</div>
					</div>
				</div>
			</div>
			<div className="footer-image w-100 text-center">
				<img src="\images\building-inner.svg.svg" className="img-fluid" />
			</div>
		</Layout>
	);
};

export default LocationDetail;
